export default "__VITE_ASSET__D0KheCk5__"